import { Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import { useDisciplines, useDisciplineUsers } from 'src/query/taskCtrl'
import Select from '../input/Select'
import { ValidateRes } from 'src/service/OrgSyncService'

export interface IChangeDiscipline {
  newDisciplineId?: number
  newResponsibleId?: number
  show: boolean
  oldDisciplineId?: number
  oldUserId?: number
}

interface MigrateChangeDisciplineProps extends IChangeDiscipline {
  projectId: number
  onClose: () => void
  onSave: (validRes?: ValidateRes) => void
}

const MigrateChangeDiscipline: FC<MigrateChangeDisciplineProps> = ({
  newDisciplineId,
  newResponsibleId,
  oldDisciplineId,
  oldUserId,
  show,
  onClose,
  onSave,
  projectId,
}) => {
  const [disciplineId, setDisciplineId] = useState(newDisciplineId)
  const [responsibleId, setResponsibleId] = useState(newResponsibleId)

  const { data: disciplines = [] } = useDisciplines(projectId)
  const { data: disciplineUsers } = useDisciplineUsers({
    discipline: disciplineId,
  })

  useEffect(() => {
    setDisciplineId(newDisciplineId)
    setResponsibleId(newResponsibleId)
  }, [newDisciplineId, newResponsibleId])

  const onSaveItem = () => {
    if (disciplineId === undefined || responsibleId === undefined) {
      return
    }
    const discipline = disciplines.find((d) => d.id === disciplineId)
    const responsible = disciplineUsers?.find((u) => u.id === responsibleId)
    onSave({
      disciplines: {
        [oldDisciplineId ?? -1]: discipline ?? null,
      },
      users: {
        [oldUserId ?? -1]: responsible ?? null,
      },
    })
  }
  return (
    <Modal
      title="Change Discipline/Responsible"
      open={show}
      centered
      onOk={onSaveItem}
      onCancel={onClose}
      mask={false}
      okButtonProps={{
        className: '!bg-[#1677ff] hover:scale-105',
      }}
    >
      <div className="flex flex-col py-4">
        <Select
          onChange={setDisciplineId}
          name={['shortName', 'name']}
          value={disciplineId}
          label={'Disciplines'}
          items={disciplines}
          error={!disciplineId || disciplineId < 0}
          placeholder="Select discipline"
          id={'id'}
        />
        <div className="mt-2" />
        <Select
          onChange={setResponsibleId}
          name={['firstName', 'lastName']}
          value={responsibleId}
          label={'Responsible*'}
          items={disciplineUsers ?? []}
          error={!responsibleId || responsibleId < 0}
          placeholder={
            !responsibleId
              ? 'Select a discipline to show available users'
              : 'Select responsible'
          }
          id={'id'}
        />
      </div>
    </Modal>
  )
}

export default MigrateChangeDiscipline
